<template>
  <div class="student-typer-page">
    <shared-header />
    <div class="student-my-assignments">
      <el-card class="main-card" shadow="hover">
        <template #header>
          <span class="card-title">我的作业</span>
          <p class="card-desc">点击下方一行进入该作业的练习页面。</p>
        </template>

        <div v-loading="listLoading" class="table-wrap">
          <el-table
            :data="assignments"
            stripe
            border
            highlight-current-row
            empty-text="暂无布置的打字作业"
            :row-class-name="assignmentRowClassName"
            style="width: 100%"
            @row-click="onRowClick"
          >
            <el-table-column type="expand" width="52">
              <template #default="{ row }">
                <div class="assignment-results-expand">
                  <div class="result-title">提交记录</div>
                  <div v-if="!row.results.length" class="row-hint">暂无提交记录</div>
                  <el-table v-else :data="row.results" size="small" border>
                    <el-table-column prop="wpm" label="WPM" width="90" />
                    <el-table-column prop="typedCount" label="打词数" width="100" />
                    <el-table-column prop="timeUsed" label="用时(秒)" width="100" />
                    <el-table-column label="通过" width="90" align="center">
                      <template #default="{ row: result }">
                        <el-tag :type="resultPassTagType(result.passed)" size="small">
                          {{ result.passed ? '通过' : '未通过' }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column label="完成全文" width="100" align="center">
                      <template #default="{ row: result }">{{ result.finished ? '是' : '否' }}</template>
                    </el-table-column>
                    <el-table-column prop="createdAt" label="提交时间" min-width="160" />
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="作业标题" min-width="180" show-overflow-tooltip />
            <el-table-column label="状态" width="112" align="center">
              <template #default="{ row }">
                <el-tag :type="statusTagType(row.status)" effect="light" size="small" class="status-tag">
                  {{ row.statusLabel }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="wpm" label="WPM 要求" width="100" />
            <el-table-column prop="standardRate" label="准确率%" width="100" />
            <el-table-column prop="countdown" label="计时(秒)" width="100" />
            <el-table-column prop="assignedAt" label="布置时间" width="155" />
          </el-table>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import SharedHeader from '../../shared/SharedHeader.vue'
import { ElMessage } from 'element-plus'
import {
  normalizeTyperAssignmentList,
  unwrapApiData
} from '../../../utils/typerNormalize'

export default {
  name: 'StudentMyTypingAssignments',
  components: { SharedHeader },
  data () {
    return {
      assignments: [],
      listLoading: false
    }
  },
  mounted () {
    this.loadList()
  },
  methods: {
    formatToMinute (value) {
      if (value == null || value === '') return '—'
      const s = String(value).trim()
      if (!s) return '—'
      // 统一到分钟显示：YYYY-MM-DD HH:mm
      const normalized = s.replace('T', ' ')
      if (normalized.length >= 16) return normalized.slice(0, 16)
      return normalized
    },
    loadList () {
      const sid = localStorage.getItem('userId')
      if (!sid) {
        this.assignments = []
        return
      }
      this.listLoading = true
      this.$store
        .dispatch('TyperAssignment/getStudentAssignments', {
          studentId: sid
        })
        .then((response) => {
          const rawList = unwrapApiData(response)
          const list = Array.isArray(rawList) ? rawList : []
          this.assignments = normalizeTyperAssignmentList(list, {
            studentId: sid,
            formatToMinute: this.formatToMinute
          })
        })
        .catch((err) => {
          console.error(err)
          this.assignments = []
          const d = err.response?.data
          const msg =
            (typeof d === 'string' && d) ||
            d?.message ||
            d?.title ||
            err.message ||
            '加载作业失败'
          ElMessage.error(String(msg))
        })
        .finally(() => {
          this.listLoading = false
        })
    },

    onRowClick (row, column) {
      if (column?.type === 'expand') return
      if (!row?.id) return
      this.$router.push({
        path: '/vocTyper',
        query: { assignmentId: row.id }
      })
    },

    statusTagType (status) {
      const map = {
        pending: 'warning',
        submitted: 'primary',
        graded: 'success'
      }
      return map[status] || 'info'
    },
    resultPassTagType (passed) {
      return passed ? 'success' : 'danger'
    },

    assignmentRowClassName ({ row }) {
      const s = row.status || 'pending'
      return `assignment-row assignment-row--${s}`
    }
  }
}
</script>

<style scoped lang="scss">
.student-typer-page {
  text-align: left;
}

.student-my-assignments {
  max-width: 1000px;
  margin: 24px auto;
  padding: 0 16px;
}

.main-card {
  border-radius: 8px;
}

.card-title {
  font-size: 1.15rem;
  font-weight: 600;
}

.card-desc {
  margin: 8px 0 0;
  font-size: 13px;
  color: var(--el-text-color-secondary);
  line-height: 1.5;
}

.table-wrap {
  min-height: 120px;
}

.status-tag {
  font-weight: 500;
}
.assignment-results-expand {
  padding: 8px 12px;
}
.result-title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
}

.row-hint {
  margin: 12px 0 0;
  font-size: 12px;
  color: var(--el-text-color-secondary);
}

:deep(.el-table .assignment-row--pending > td.el-table__cell) {
  background-color: #fdf6ec !important;
}

:deep(.el-table .assignment-row--submitted > td.el-table__cell) {
  background-color: #ecf5ff !important;
}

:deep(.el-table .assignment-row--graded > td.el-table__cell) {
  background-color: #f0f9eb !important;
}

:deep(.el-table__body tr) {
  cursor: pointer;
}
</style>
